// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import type { Node } from 'react'
import styled, { type StyledComponent } from 'styled-components'

const SelectInputWrapper: StyledComponent<Object, any, any> = styled.select`
  padding-left: 8px;
  padding-right: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 35px;
  &:not(.disabled) {
    cursor: pointer;
  }

  -webkit-appearance: none;
  -moz-appearance: none;

  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%);
  background-position: calc(100% - 10px) calc(1em + 1px), calc(100% - 5px) calc(1em + 1px),
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;

  ${({ width }: Object) => (width ? `width: ${width}px` : 'width: 100%')};
`

type OptionType = {|
  id: any,
  name: string
|}

type Props = {|
  id?: string,
  className?: string,
  value: any,
  onChange: Function,
  children?: Node,
  width?: number,
  htmlProperties?: Object,
  options?: Array<OptionType>
|}

export default class NativeSelect extends Component<Props> {
  render() {
    return (
      <SelectInputWrapper
        width={this.props.width}
        id={this.props.id}
        className={this.props.className}
        value={this.props.value}
        {...this.props.htmlProperties}
        onChange={(e) => this.changed(e)}
      >
        {this.props.children
          ? this.props.children
          : _.map(this.props.options, (option) => this.renderOption(option))}
      </SelectInputWrapper>
    )
  }

  changed(e: any) {
    const value = this.props.options
      ? (_.find(this.props.options, (option) => option.id.toString() === e.target.value) || {}).id
      : e.target.value

    this.props.onChange(value)
  }

  renderOption(option: OptionType) {
    return (
      <option key={option.id} value={option.id}>
        {option.name}
      </option>
    )
  }
}
